import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { ArrowRight } from '@finect/tabular-icons/arrowRight';
import { Inner, Content, Footer, Title, Description, Label } from './partials';
export var TipCard = function TipCard(_ref) {
  var title = _ref.title,
    description = _ref.description,
    href = _ref.href,
    primaryBackground = _ref.primaryBackground,
    _ref$rel = _ref.rel,
    rel = _ref$rel === void 0 ? null : _ref$rel;
  var url = href;
  return React.createElement(Inner, {
    href: url,
    primaryBackground: primaryBackground || false
  }, React.createElement(Content, {
    primaryBackground: primaryBackground || false
  }, React.createElement(Title, null, title), React.createElement(Description, null, React.createElement("span", null, description))), React.createElement(Footer, null, url ? React.createElement(Label, {
    as: AppLink,
    href: url,
    rel: rel
  }, "Ver m\xE1s", React.createElement(ArrowRight, {
    size: "18px",
    strokeWidth: "2"
  })) : null));
};